import react_logo from '../../image/logo_folder/react_img.png';
import node_logo from '../../image/logo_folder/node_img.png';
import html_logo from '../../image/logo_folder/html_img.png';
import css_logo from '../../image/logo_folder/css_img.png';
import netlify_logo from '../../image/logo_folder/netlify_img.png';
import bootstrap_logo from '../../image/logo_folder/bootstrap_img.png';
import javascript_logo from '../../image/logo_folder/javascript_img.png';
import github_logo from '../../image/logo_folder/github_img.png';
import mongoDB_logo from '../../image/logo_folder/mongoDB_img.png';
import material_logo from '../../image/logo_folder/material_img.png';
import git_logo from '../../image/logo_folder/git_img.png';
import express_logo from '../../image/logo_folder/express_img.png';
import vercel_logo from '../../image/logo_folder/vercel.png';
import typescript_logo from '../../image/logo_folder/typescript_img.png';
import redux_logo from '../../image/logo_folder/react_img.png';
import tailwind_logo from '../../image/logo_folder/tailwind_img.png';

const my_skills_data = [
  {
    id: 1,
    skill_name: 'React JS',
    img_link: react_logo,
  },
  // {
  //   id: 2,
  //   skill_name: 'Redux',
  //   img_link: redux_logo,
  // },

  {
    id: 3,
    skill_name: 'JavaScript',
    img_link: javascript_logo,
  },
  {
    id: 4,
    skill_name: 'Typescript',
    img_link: typescript_logo,
  },
  {
    id: 5,
    skill_name: 'Node JS',
    img_link: node_logo,
  },
  {
    id: 6,
    skill_name: 'Express JS',
    img_link: express_logo,
  },
  {
    id: 7,
    skill_name: 'HTML5',
    img_link: html_logo,
  },
  {
    id: 8,
    skill_name: 'CSS3',
    img_link: css_logo,
  },
  {
    id: 9,
    skill_name: 'Tailwind',
    img_link: tailwind_logo,
  },
  {
    id: 10,
    skill_name: 'Bootstrap',
    img_link: bootstrap_logo,
  },
  {
    id: 11,
    skill_name: 'Material UI',
    img_link: material_logo,
  },

  {
    id: 13,
    skill_name: 'Mongodb',
    img_link: mongoDB_logo,
  },

  {
    id: 15,
    skill_name: 'GitHub',
    img_link: github_logo,
  },
  {
    id: 16,
    skill_name: 'Git VCS',
    img_link: git_logo,
  },

  {
    id: 18,
    skill_name: 'Netlify',
    img_link: netlify_logo,
  },
];
export default my_skills_data;
